(function($){
    $(function(){
        var $clientCard = $('.zn-client-card.zn-internal .zn-client-link');

        if ($clientCard.length){
            $clientCard.each(function(idx, itm){
                var $ex = $(itm),
                    exID = 'zn-internal-' + idx;

                $ex.find('.zn-card-body').attr('id', exID);
                $ex.attr('role', 'button').attr('aria-expanded', 'false').attr('aria-controls', exID);
            });

            $clientCard.on('click', function(e){
                e.preventDefault();

                var $this = $(this);

                $this.attr('aria-expanded', function(index, attr){
                    return attr === 'true' ? 'false' : 'true';
                }).parent('.zn-client-card').toggleClass('zn-active');
            });
        }
    });
})($JQ);
